/**
 * The nihul surfaces: the /nihul app plus the nihul pages that were given their own
 * public-site address (hofesh limud manage). ONE list serving two consumers that must
 * never drift apart: NihulAccessService's login-return allowlist, and the site header's
 * internal-surface test (no ads, no broadcast-notification prompt over an editor's
 * screen). A new own-address surface added here gets both behaviors at once - the
 * 2026-08 popup-in-the-nihul bug was exactly this list existing in one place and not
 * the other. All values are internal Angular routes of THIS site - never a cms address.
 *
 * A leaf module on purpose (no imports): the eagerly-loaded site header pulls only this
 * file into the main bundle, not the lazy nihul area.
 */
export const NIHUL_SURFACE_PATH_PREFIXES = ['/nihul', '/hofeshlimud/manage'];

/** true when the url (a router url or pathname; query/fragment tolerated) is a nihul surface */
export function isNihulSurfaceUrl(url: string): boolean {
    const path = url.split(/[?#]/)[0].toLowerCase();
    return NIHUL_SURFACE_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

/**
 * The PUBLIC pages that carry no ads (Baruch 2026-10-20: "the moment the order process starts,
 * the advertisement should not show"): the store's order flow (/store/<slug>/order and its
 * steps) and a customer's order page (/store/order/<token>). A separate test from the nihul one
 * on purpose - these are public pages (login-return, language, the broadcast prompt all stay
 * as on any public page); only the ads go.
 */
export function isAdFreeUrl(url: string): boolean {
    const path = url.split(/[?#]/)[0].toLowerCase();
    return /^\/store\/(order\/[^/]+|[^/]+\/order)(\/|$)/.test(path);
}

/**
 * The whole Shabbat store (/store and everything under it). The BOTTOM ad - the sticky footer
 * leaderboard, the mobile strip - never shows anywhere in the store (the manager via Baruch
 * 2026-10-22), unlike the top ad, which goes only once the order process starts (isAdFreeUrl).
 */
export function isStoreUrl(url: string): boolean {
    const path = url.split(/[?#]/)[0].toLowerCase();
    return path === '/store' || path.startsWith('/store/');
}
